var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DateUtils from "../../../../util/dateUtils";
import TranscriptCourseAttendanceStatusService from "../../../Domain/TranscriptCourseAttendanceStatus/TranscriptCourseAttendanceStatus.service";
import FAIcon from "../../UI/FAIcon/FAIcon";
const makeAttendanceStatusIcon = (icon, color, makeTitle) => (_a) => {
    var { date, className } = _a, otherProps = __rest(_a, ["date", "className"]);
    return (_jsx(FAIcon, Object.assign({}, otherProps, { icon: icon, type: "fas", className: `attendance-indicator text-${color} ${className || ""}`, title: makeTitle(date), "aria-label": makeTitle(date) })));
};
export const PresentIcon = makeAttendanceStatusIcon("check-circle", "success", (date) => (date ? `Present on ${DateUtils.shortDate(date)}` : "Present"));
export const TardyIcon = makeAttendanceStatusIcon("clock", "warning", (date) => date ? `Tardy on ${DateUtils.shortDate(date)}` : "Present");
export const AbsentIcon = makeAttendanceStatusIcon("times-circle", "danger", (date) => (date ? `Absent on ${DateUtils.shortDate(date)}` : "Absent"));
export const CancelledIcon = makeAttendanceStatusIcon("times", "muted", (date) => date
    ? `Class for ${DateUtils.shortDate(date)} was cancelled`
    : "Meeting was cancelled");
export const ExcusedIcon = makeAttendanceStatusIcon("file-alt", "info", (date) => (date ? `Excused on ${DateUtils.shortDate(date)}` : "Excused"));
export const UnknownIcon = makeAttendanceStatusIcon("question-circle", "muted", (date) => (date ? `Unknown on ${DateUtils.shortDate(date)}` : "Unknown"));
export const EntryIcon = makeAttendanceStatusIcon("sign-in", "", (date) => date ? `Entered on ${DateUtils.shortDate(date)}` : "Entry");
const AttendanceIcon = (_a) => {
    var { attendanceStatusId, isCancelled } = _a, otherProps = __rest(_a, ["attendanceStatusId", "isCancelled"]);
    if (isCancelled) {
        return _jsx(CancelledIcon, Object.assign({}, otherProps));
    }
    switch (attendanceStatusId) {
        case TranscriptCourseAttendanceStatusService.AbsentId:
            return _jsx(AbsentIcon, Object.assign({}, otherProps));
        case TranscriptCourseAttendanceStatusService.TardyId:
            return _jsx(TardyIcon, Object.assign({}, otherProps));
        case TranscriptCourseAttendanceStatusService.PresentId:
            return _jsx(PresentIcon, Object.assign({}, otherProps));
        case TranscriptCourseAttendanceStatusService.EntryId:
            return _jsx(EntryIcon, Object.assign({}, otherProps));
        default:
            return _jsx(UnknownIcon, Object.assign({}, otherProps));
    }
};
export default AttendanceIcon;
